import {routes as authRoutes} from '~/cores/auth/routes'
import {routes as homeRoutes} from '~/cores/home/routes'
import {routes as firmRoutes} from '~/cores/firms/routes'
import {routes as searchRoutes} from '~/cores/search/routes'
import {routes as settingsRoutes} from '~/cores/settings/routes'
import {routes as billingRoutes} from '~/cores/billing/routes'
import {routes as dataRoutes} from '~/cores/data/routes'

export const routes = (
	<>
		{authRoutes}
		{homeRoutes}
		{firmRoutes}
		{searchRoutes}
		{settingsRoutes}
		{billingRoutes}
		{dataRoutes}
	</>
)
